import React from "react"
import { useTranslation } from "react-i18next"
import styles from "./ErrorPage.module.scss"

interface ErrorPageProps {
    title?: string
    message?: string
}

const ErrorPageComponent: React.FC<ErrorPageProps> = ({ title, message }) => {
    const { t, i18n } = useTranslation("common")
    const homePath = i18n.language === "pt" ? "/pt" : "/"
    return (
        <div className={styles.page}>
            <div className={styles.card}>
                <h1 className={styles.title}>{title ?? t("errorPage.title")}</h1>
                <p className={styles.message}>{message ?? t("errorPage.message")}</p>

                <a href={homePath} className={styles.button}>
                    {t("errorPage.goHome")}
                </a>
            </div>
        </div>
    )
}

export default ErrorPageComponent
